"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Armen Avagumyan. Created on 4/20/2019.
 */
var Performance = /** @class */ (function () {
    function Performance(achievement, progress) {
        this.achievement = achievement;
        this.progress = progress;
    }
    Performance.emptyInstance = function () {
        return new Performance(null, null);
    };
    return Performance;
}());
exports.Performance = Performance;
//# sourceMappingURL=performance.model.js.map